import { Outlet } from 'react-router-dom';
import { VStack } from '@cbhq/cds-web/layout';

import { PageLayoutProps } from './props';
import { useSmoothInitialRender } from './useSmoothInitialRender';

export function MobileLayout({ inSecurityFrame }: PageLayoutProps) {
  const { background, opacity } = useSmoothInitialRender(inSecurityFrame);

  return (
    <VStack justifyContent="flex-start" alignItems="center" minHeight="100vh">
      <VStack
        position="relative"
        background={background}
        opacity={opacity}
        maxWidth={500}
        width="100%"
        minHeight={400}
        maxHeight="auto"
        overflow="auto"
        spacing={2}
      >
        <Outlet />
      </VStack>
    </VStack>
  );
}
